module.exports = __webpack_public_path__ + "img/wechat-cards3.4585e585.png";